import config from '../../lib/config'

import PageMixins from '../../components/_mixins/pages'
import {
  ValidationMixins,
  setValidationRule,
  parseValidationSetup,
  parseValidations,
  truthyRule,
  passwordRules,
  passwordConfirmationRules,
  emailConfirmationRules,
  phoneConfirmationRules,
} from '../../lib/validations'

// const { validationMixin, default: Vuelidate } = require('vuelidate')
import ProviderService from '../../services/provider'
import MainService from '../../services/main'

import {now, DateTime, Settings} from '../../lib/dates'
import {countries, states, get$} from '../../lib/utils'
Settings.defaultLocale = "en-us"

import {Datetime} from 'vue-datetime-extended'
import 'vue-datetime-extended/dist/vue-datetime-extended.css'

const EventBus = window.VueEventBus

const validations = {
  first_name: setValidationRule('fields.first_name'),
  last_name: setValidationRule('fields.last_name'),
  email: setValidationRule('fields.email', {
    required: {error: 'Email is required.'},
    email: {error: 'Email is not valid.'},
  }),
  email_confirmation: setValidationRule('fields.email_confirmation', emailConfirmationRules),
  password: setValidationRule('fields.password', passwordRules),
  password_confirmation: setValidationRule('fields.password_confirmation', passwordConfirmationRules),
  birth_date: setValidationRule('fields.birth_date'),
  address: setValidationRule('fields.address', 'Address'),
  city: setValidationRule('fields.city'),
  state: setValidationRule('fields.state'),
  zip: setValidationRule('fields.zip'),
  country: setValidationRule('fields.country'),
  phone: setValidationRule('fields.phone', {
    required: {error: 'Mobile phone is required.'},
  }),
  phone_confirmation: setValidationRule('fields.phone_confirmation', phoneConfirmationRules),
  //
  // terms: setValidationRule('fields.terms', {
  //   truthy: {error: 'Please agree to the Terms & Conditions', rule: truthyRule},
  // }),

}

export default {
  name: 'page-raceway-registration',
  settings: 'page.registration',
  translations: 'page.registration',
  mixins: [PageMixins, ValidationMixins],
  components: {Datetime},
  props: ['terms'],
  data() {
    return {
      now: now.toISODate(),
      termsUrl: null,
      registrationError: '',
      isSubmitting: false,
      isFormDisabled: false,
      createdEmail: null,
      successResend: false,
      resendCount: -1,
      fields: {
        first_name: '',
        last_name: '',
        clubspeed_racername: null,

        email: null,
        email_confirmation: null,

        password: null,
        password_confirmation: null,

        gender: null,
        birth_date: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: 'US',

        phone: null,
        phone_confirmation: null,
        clubspeed_discovery: 0,

        subscribe: false,
        terms: true,
      },
      sources: {
        countries,
        states,
        // howDoYouKnow: config.clubspeed.sources,
      },
      validations: parseValidationSetup(validations, this),

    }
  },
  validations: {fields: parseValidations(validations)},
  mounted() {
  },
  created() {
    // window.skipGlobalTimerMessage = true
    this.termsUrl = this.terms || '/terms-of-use'
  },
  computed: {},
  methods: {
    async resendConfirmation() {
      const email = this.createdEmail
      this.isSubmitting = true
      this.successResend = false
      try {
        const data = await MainService.sendConfirmation({email})
        this.resendCount++
        this.successResend = true
      } catch (e) {
        this.alert(MainService.getFirstErrorMessage(e))
      }
      this.isSubmitting = false
    },
    showConfirmation() {
      this.createdEmail = this.fields.email
    },
    async registerNow() {

      this.$v.$touch()
      this.formSubmitting = true

      const fields = _.clone(this.fields)
      const publicFields =_.omit(fields, ['password', 'password_confirmation'])
      EventBus.$emit('user.registration.before', publicFields)

      if (!this.isAnyInvalid) {
        this.registrationError = ''
        this.isSubmitting = true
        this.isFormDisabled = true
        const {fields} = this
        let result = {}
        try {
          result = await ProviderService.register(fields)
        } catch (e) {
          this.registrationError = ProviderService.getFirstErrorMessage(e) || 'Ops! unable to register! Please try again.'
          this.isFormDisabled = false
        }

        if (!this.registrationError) {

          if (result.success) {

            result.email = fields.email
            let redirect = this.loginRedirect

            if (redirect === 'page-checkout' || redirect === 'page-cart') {

              this.saveToken({
                token: result.access_token
              })
              try {
                await this.fetchUser()
              } catch (error) {

                this.registrationError = error.response.data.message
                this.isFormDisabled = false
              }

              this.setPostLoginPage(null)
              this.setIsPreCheckoutRegistration(true)
              this.goto(redirect)

            } else {
              this.showConfirmation()
            }

          } else {
            this.registrationError = result.error
            this.isFormDisabled = false
          }
        }
        this.isSubmitting = false
        this.scrollTo(get$('.page-registration'))

      } else {
        this.scrollToFirstErrorElement()
      }

    }
  }
}
